import { Close } from '@mui/icons-material';
import { IconButton, InputAdornment, MenuItem, Popover, TextField, Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export type ListProps = {
    open: boolean;
    anchorEl: HTMLElement | null;
    searchInputRef: React.RefObject<HTMLInputElement | null>;
    containerRef: React.RefObject<HTMLDivElement | null>;
    searchText: string;
    options: any[];
    onClose: () => void;
    onChangeSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSelectOption: (selectedId: number) => () => void;
    onClearSearch: () => void;
};

export const List = ({
    open,
    anchorEl,
    searchInputRef,
    containerRef,
    searchText,
    options,
    onClose,
    onChangeSearch,
    onSelectOption,
    onClearSearch
}: ListProps) => (
    <Popover
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { borderRadius: '8px', ml: '7px', mt: '5px', width: containerRef.current?.clientWidth || '200px' } }}
    >
        <TextField
            variant="filled"
            size="small"
            inputRef={searchInputRef}
            InputProps={{
                hiddenLabel: true,
                disableUnderline: true,
                sx: { bgcolor: '#F5F6F7' },
                endAdornment: searchText.length ? (
                    <InputAdornment position="end">
                        <IconButton aria-label="clear search" onClick={onClearSearch} edge="end">
                            <Close />
                        </IconButton>
                    </InputAdornment>
                ) : undefined
            }}
            value={searchText}
            onChange={onChangeSearch}
            autoFocus
            fullWidth
        />
        {options.length ? (
            options.map((el) => (
                <MenuItem
                    sx={{ border: 'solid 1px #D9D9D9', height: '40px', px: '12px', bgcolor: '#F5F6F7' }}
                    key={el.id}
                    onClick={onSelectOption(el.id)}
                    disabled={!el.enabled}
                >
                    <Typography
                        color="#37326E"
                        fontSize="14px"
                        sx={{ overflow: 'hidden', width: '100%', textDecoration: 'underline', textOverflow: 'ellipsis' }}
                    >
                        {!el.enabled && '(Disabled)'} {el.label}
                    </Typography>
                </MenuItem>
            ))
        ) : (
            <Typography fontSize="14px" sx={{ py: 2, px: 1 }} color="#C6C4C4" align="center">
                <FormattedMessage id="noOptionsAvailable" />
            </Typography>
        )}
    </Popover>
);
